// extracted by mini-css-extract-plugin
export var button = "_g-0";
export var buttonContent = "_g-e";
export var buttonGroup = "_g-c";
export var dontRestrainIconWidth = "_g-a";
export var dropdownButton = "_g-b";
export var iconContainer = "_g-9";
export var lg = "_g-4";
export var md = "_g-3";
export var pending = "_g-f";
export var sm = "_g-2";
export var spinner = "_g-d";
export var squared = "_g-8";
export var wrapText = "_g-g";
export var xl = "_g-5";
export var xs = "_g-1";
export var xxl = "_g-6";
export var xxxl = "_g-7";